import { SubmissionItem } from '../types';

/**
 * 作品プレビューモーダル
 * SYSTEM_DESIGN.md §3.3, §7.2 準拠
 */
export function openPreviewModal(submission: SubmissionItem): void {
  const modalRoot = document.getElementById('modal-root')!;
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay active';

  // HTMLコンテンツのBlob URL（安全なプレビュー）
  let blobUrl = '';
  if (submission.htmlContent) {
    const blob = new Blob([submission.htmlContent], { type: 'text/html' });
    blobUrl = URL.createObjectURL(blob);
  }

  overlay.innerHTML = `
    <div class="modal-dialog modal-lg" role="dialog" aria-modal="true" aria-labelledby="preview-title" style="display: flex; flex-direction: column;">
      <div class="modal-header">
        <div class="modal-title" id="preview-title">
          <span>🎮</span>
          <span>${escapeHtml(submission.title)}</span>
          <span style="font-size: 12px; font-weight: normal; color: var(--color-text-secondary); margin-left: 8px;">
            by ${escapeHtml(submission.author)} (${submission.genre})
          </span>
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          ${blobUrl ? `
            <a href="${blobUrl}" target="_blank" rel="noopener noreferrer" class="btn btn-outlined btn-sm" title="新しいタブで直接開く">
              別タブで開く ↗
            </a>
          ` : `
            <a href="${submission.htmlUrl}" target="_blank" rel="noopener noreferrer" class="btn btn-outlined btn-sm">
              別タブで開く ↗
            </a>
          `}
          <button id="btn-close-preview" class="btn btn-text btn-sm" type="button" style="font-size: 16px;">✕</button>
        </div>
      </div>

      <div style="flex: 1; position: relative; background: #ffffff; display: flex; flex-direction: column; overflow: hidden;">
        <!-- サンドボックス iframe -->
        <iframe
          id="preview-frame"
          class="preview-iframe-wrapper"
          sandbox="allow-scripts allow-forms allow-popups"
          src="${blobUrl || submission.htmlUrl}"
          title="${escapeHtml(submission.title)}"
        ></iframe>
      </div>

      <div class="modal-footer" style="justify-content: space-between; font-size: 12px; color: var(--color-text-secondary);">
        <div>
          <span>提出日: ${new Date(submission.submittedAt).toLocaleDateString('ja-JP')}</span>
          ${submission.description ? `<span style="margin-left: 16px;">説明: ${escapeHtml(submission.description)}</span>` : ''}
        </div>
        <div>
          <span class="card-badge ${submission.visibility === 'public' ? 'badge-public' : 'badge-private'}" style="position: static; padding: 4px 8px;">
            ${submission.visibility === 'public' ? '🌐 完全公開' : '🔒 限定公開'}
          </span>
        </div>
      </div>
    </div>
  `;

  modalRoot.appendChild(overlay);

  const cleanup = () => {
    overlay.classList.remove('active');
    setTimeout(() => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 200);
  };

  overlay.querySelector('#btn-close-preview')!.addEventListener('click', cleanup);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) cleanup();
  });
}

function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
